<template>
  <b-overlay :show="pageloading" rounded="sm">
  <h5 class="mb-3">會員資料</h5>
  <b-card v-if="show" no-body class="overflow-hidden shadow-lg" >
    <b-row no-gutters>
      <b-col md="6">
        <b-card-img v-if="Profile.vip==0 && Profile.sales==0" src="https://www.name-q.com/assets/app/registerCard.png" alt="Image" class="rounded-0"></b-card-img>
        <b-card-img v-if="Profile.vip==1 && Profile.sales==0" src="https://www.name-q.com/assets/app/goldmember.png" alt="Image" class="rounded-0"></b-card-img>
        <b-card-img v-if="Profile.sales==1" src="https://www.name-q.com/assets/app/salesmember.png" alt="Image" class="rounded-0"></b-card-img>
      </b-col>
      <b-col md="6">
        <b-card-body title="會員資格">
          <b-card-text>

            <p v-if="Profile.vip==0 && Profile.sales==0">
              會員等級：註冊會員<br>
              會員資格起：{{ Profile.create_date}}<br>
              會員資格止：無</p>
            <b-button v-if="Profile.vip==0 && Profile.sales==0" href="#" variant="success" to="/Payment/Plan">購買方案</b-button>
            <p v-if="Profile.vip==1 && Profile.sales==0">
              會員等級：{{ Profile.vip_lv==2?'黃金會員':''}}<br>
              會員資格起：{{ Profile.vip_starttime}}<br>
              會員資格止：{{ Profile.vip_endtime}}</p>
            <p v-if="Profile.sales==1 ">
              <span v-if="Profile.sales_lv==1">會員等級：業務會員</span>
              <span v-if="Profile.sales_lv==2">會員等級：業務會員</span>
              <span v-if="Profile.sales_lv==3">會員等級：代理會員</span>
              <span v-if="Profile.sales_lv==4">會員等級：股東會員</span><br>
              會員資格起：{{ Profile.sales_startime}}<br>
              會員資格止：{{ Profile.sales_endtime}}</p>
            <div v-if="Profile.vip==1 && Profile.sales==0 && UserPlan.resume.length > 0">
              <h5>{{ UserPlan.resume[0].product_name }}</h5>
              <p>{{ UserPlan.resume[0].product_desc }}</p>
              <b-button href="#" variant="success" @click="gotocheckOut( UserPlan.resume[0],'normal')">立即續會</b-button>
            </div>
            <div v-if="Profile.sales==1 && Profile.sales_lv <=3 && UserPlan.resume.length > 0">
              <h5>{{ UserPlan.resume[0].product_name }}</h5>
              <p>{{ UserPlan.resume[0].product_desc }}</p>
              <b-button href="#" variant="success" @click="gotocheckOut( UserPlan.resume[0],'normal')">立即續會</b-button>
            </div>

          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>

  <hr>
  </b-overlay>
</template>
<style>

</style>

<script>
import {mapState} from 'vuex'
export default {
  name: 'ProfileMemberCard',
  components: {},
  props: {
    Profile:Object

  },


  data () {
    return {
      UserPlan:{},
      pageloading:false,
      show:false

    }
  },
  mounted() {
    this.getUserPlan()
  },
  methods: {
    gotocheckOut(item,way){
      // console.log(item)
      // this.$store.dispatch('actionShopCart',item)
      // this.$router.push('/Payment/CheckOut');

      this.$store.dispatch('actionNBpay', {Puid:item.product_id,ChoicePay:way}).then((res) => {

        document.open();
        document.write(res);
        document.close();

      }).catch((res) => {

      })
    },
    getUserPlan(){

      this.pageloading = true
      this.$store.dispatch('actionProductNew',{})
        .then((res) => {
          this.UserPlan = res.data
          this.pageloading = false
          this.show = true
        })
        .catch((res) => {

        })
    }
  }
}
</script>
